"use client";

import { useState } from "react";
import { Switch } from "@/components/ui/switch";
import { Badge } from "@/components/ui/badge";
import { toast } from "sonner";

interface StatusCellProps {
  status: number;
  onToggle: () => Promise<void>;
}

export function DataTableStatusCell({ status, onToggle }: StatusCellProps) {
  const [loading, setLoading] = useState(false);
  const [currentStatus, setCurrentStatus] = useState(status);

  async function handleToggle() {
    const prev = currentStatus;
    setCurrentStatus(prev === 1 ? 0 : 1);
    setLoading(true);
    try {
      await onToggle();
      toast.success(`Status ${prev === 1 ? "deactivated" : "activated"}`);
    } catch {
      setCurrentStatus(prev);
      toast.error("Failed to update status");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="flex items-center gap-2">
      <Switch
        checked={currentStatus === 1}
        onCheckedChange={handleToggle}
        disabled={loading}
      />
      {/* Angular uses --green (#16a085) for Active, red for Inactive */}
      <span
        className="inline-flex items-center rounded-md px-2 py-0.5 text-xs font-semibold"
        style={
          currentStatus === 1
            ? { background: "rgba(22,160,133,0.15)", color: "#16a085", border: "1px solid rgba(22,160,133,0.35)" }
            : { background: "rgba(233,74,73,0.12)", color: "#e94a49", border: "1px solid rgba(233,74,73,0.35)" }
        }
      >
        {currentStatus === 1 ? "Active" : "Inactive"}
      </span>
    </div>
  );
}
